import { useLocation } from 'react-router-dom'
import { PageHeader as BasePageHeader } from '@platform/ui-kit'
import type { PageHeaderProps } from '@platform/ui-kit'
import { findPageIcon } from '@/app/routes/moduleRegistry'

/* ------------------------------------------------------------------
   سرصفحه صفحه — نسخهٔ متصل به رجیستری
   ------------------------------------------------------------------
   همان `PageHeader` ui-kit است، با یک تفاوت: آیکون را خودش از روی
   مسیر جاری پیدا می‌کند.

   🔴 چرا این لایه وجود دارد: ui-kit طبق قاعدهٔ بند ۵.۲ حق ندارد
   رجیستری ماژول‌های اپ را بشناسد، ولی ۳۳ صفحه هم نباید هرکدام نشانی
   فایل آیکون را دستی بنویسند — با تغییر نام یک فایل، همه بی‌صدا
   می‌شکستند. پس نگاشت یک‌جا در رجیستری می‌ماند و این لایه آن را به
   کامپوننت بی‌طرفِ پکیج وصل می‌کند.

   صفحه‌ها می‌توانند با پاس‌دادن `illustration` تصمیم رجیستری را
   بازنویسی کنند؛ و اگر مسیری آیکون نداشته باشد، سرصفحه بدون آیکون
   رندر می‌شود.
   ------------------------------------------------------------------ */

export function PageHeader({ illustration, ...props }: PageHeaderProps) {
  const location = useLocation()
  const resolved = findPageIcon(location.pathname)

  return (
    <BasePageHeader
      {...props}
      illustration={illustration ?? (resolved ? `/icons/3d/${resolved}.png` : undefined)}
    />
  )
}
